import React, { useEffect } from 'react';

import { useLocation } from '@reach/router';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';
import { Text } from 'src/components/Text';
import externalRoutes from 'src/constants/externalRoutes';
import routes from 'src/constants/routes';
import { useModalContext } from 'src/contexts/ModalContext';

import * as modalAcademyPromoStyles from './modalacademypromo.module.css';

export const ModalAcademyPromo = () => {
  const location = useLocation();
  const { close } = useModalContext();

  useEffect(() => {
    if (location.pathname === routes.academy) {
      close();
    }
  }, [close, location.pathname]);

  return (
    <Modal
      title="Akademija za predškolarce!"
      DescriptionComponent={
        <>
          <div className={modalAcademyPromoStyles.bodyContainer}>
            <div>
              <Text type="body2">
                Program koji u potpunosti priprema i osnažuje Vaše dijete za polazak u prvi razred.
              </Text>
            </div>
            <div>
              <Text type="body2">
                Sve što vam treba kako bi Vi i Vaše dijete bili spremni za nove školske avanture.
              </Text>
            </div>
            <div>
              <Text type="body3">
                <b>Bonus: svaki kupac Akademije ostvaruje pravo na 1 mjesec besplatne edukativne platforme Lumi Gumi.</b>
              </Text>
            </div>
            <div>
              <Text type="body2">Ne propustite!</Text>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              sizes={{ large: 'medium', medium: 'medium', small: 'medium', xsmall: 'small' }}
              mode={{
                type: 'anchor',
                href: externalRoutes.academyFormUrl,
                shouldOpenInNewTab: true,
              }}
              label="PRIJAVITE SE OVDJE"
            />
          </div>
        </>
      }
      hasParrot
    />
  );
};
